import {
  Button,
  Flex,
  Image,
  Link,
  Text,
  useColorModeValue
} from "@chakra-ui/react";
import React from "react";

export default function SidebarDocs() {
  const bgColor = "linear-gradient(135deg, #868CFF 0%, #4318FF 100%)";
  const borderColor = useColorModeValue("white", "navy.800");

  return (
    <Flex
      justify='center'
      direction='column'
      align='center'
      bg={bgColor}
      borderRadius='30px'
      me='20px'
      position='relative'>
      <Flex
        border='5px solid'
        borderColor={borderColor}
        //bg='linear-gradient(135deg, #868CFF 0%, #92a5c1ff 100%)'
        bg='linear-gradient(135deg, #a1a5f2ff 0%, #92a5c1ff 100%)'



        borderRadius='50%'
        w='94px'
        h='94px'
        align='center'
        justify='center'
        mx='auto'
        position='absolute'
        left='50%'
        top='-47px'
        transform='translate(-50%, 0%)'>
        {/* <Image src='./Prowess-logo.png' w='40px' h='40px' /> */}
        <Image src='./Logo-Prowess-Icon_new.png' w='40px' h='40px' />
      </Flex>
      <Flex
        direction='column'
        mb='12px'
        align='center'
        justify='center'
        px='15px'
        pt='55px'>
        <Text
          fontSize={{ base: "lg", xl: "18px" }}
          color='white'
          fontWeight='bold'
          lineHeight='150%'
          textAlign='center'
          px='10px'
          mb='14px'>
          PROWESS ERP
        </Text>
        <Text
          fontSize='14px'
          color={"white"}
          px='10px'
          mb='14px'
          textAlign='center'>
          Manage your work, attendance, and applications all in one place.
        </Text>
      </Flex>

    </Flex>
  );
}
